<template>
  <div class="parent fill-height d-flex flex-grow-1 flex-row">
    <!-- Desktop: Zwei Spalten -->
    <v-row v-if="!hasImage" no-gutters style="max-width: fit-content;" class=" flex-wrap flex-row fill-height  mx-1 flex-grow-1">
      <v-col :cols="12" class="scrolling-child">
        <slot name="right-column"></slot>
      </v-col>
    </v-row>
    <v-row v-else-if="!$vuetify.breakpoint.smAndDown" no-gutters style="max-width: 100%;"  class="flex-wrap fill-height  mx-2 flex-row">
      <v-col :cols="isFlipped ? 4 : 8" class="fixed-child">
        <slot name="left-column"></slot>
      </v-col>
      <v-col cols="auto" class="d-flex align-center justify-center ml-n10">
        <v-btn @click="isFlipped = !isFlipped" color="primary" fab small>
          <v-icon>mdi-swap-horizontal</v-icon>
        </v-btn>
      </v-col>
      <v-col :cols="isFlipped ? 8 : 4" class="scrolling-child">
        <slot name="right-column"></slot>
      </v-col>
    </v-row>

    <!-- Mobile: Tabs -->
    <div v-else class="d-flex flex-column fill-height">
      <!-- Tabs mit fixer Höhe -->
      <v-tabs background-color="black" dark v-if="hasImage" v-model="activeTab" grow   height="48" class="flex-shrink-0" >
        <v-tab value="left">{{isMedia ? "Media" : "Images"}}</v-tab>
        <v-tab value="right">Details</v-tab>
      </v-tabs>

      <!-- Tab-Inhalte sollen sich normal verhalten -->
      <div v-show="activeTab === 0" class="fixed-child">
        <div class="slot-wrapper">
          <slot name="left-column" class="fill-height"></slot>
        </div>
      </div>
      <div v-show="activeTab === 1" class="fill-height">
        <div  class="scrolling-child">
          <slot name="right-column"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ResponsiveDesignLayer",
  props: {
    isMedia: {
      type: Boolean,
      default: false
    },
    hasImage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: "left",
      isFlipped: false,
    };
  },
  methods: {

  },
  watch: {
    isFlipped() {
      this.$emit("isFlipped", this.isFlipped);
    },
    activeTab() {
      this.$emit("isFlipped", this.isFlipped);
      this.$log.debug("activeTab:", this.activeTab);
    }
  },
  mounted() {
    if (this.hasImage) {
      this.activeTab = 1
    }
    this.$log.debug("mounted designLayer", this.$vuetify.breakpoint.smAndDown, this.hasImage);
  }
};
</script>
<style scoped>
  .fill-height {
    height: 100%;
    min-height: 100% ;
    width: 100%;
    overflow: hidden;
  }
  .fixed-child {
    height: 100%;
    width: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .scrolling-child {
    overflow-x: hidden;
    flex: 1;
    flex-direction: column;
    display: flex;
    height: 100%;
    width: 100%;
    flex-direction: column;
    overflow-y: auto;
    min-height: 0;
    padding-right: 20px !important;
  }
  .v-tab--active {
    background-color: var(--v-primary-base)!important;
  }
  .slot-wrapper {
    width: 100Vw;
    height: 100%;
    display: flex;
    flex-direction: column;
    max-width: 100%;
  }
</style>